// extracted by mini-css-extract-plugin
export default {"root":"style_root__R8W2R","loader":"style_loader__1x+iO","load":"style_load__ALihw"};